<template>
    <v-container grid-list-md fluid>
        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="12">
                <v-row no-gutters cols="12" class="my-3 justify-center">
                    <v-col cols="2">
                        <v-btn-primary
                            block
                            @click="$router.push({ name: 'new-booklet-template' })"
                        >
                            Ajouter
                        </v-btn-primary>
                    </v-col>
                    <v-col class="pl-2">
                        <v-text-field
                            v-model="search"
                            label="Recherche"
                            append-inner-icon="$search"
                            clearable
                            @click:clear="search = ''"
                            outlined
                            hide-details
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="2" class="pl-2">
                        <v-combobox
                            v-model="filterCompany"
                            :items="allAvailableCompanies"
                            label="Société"
                            hide-details
                        >
                        </v-combobox>
                    </v-col>
                </v-row>
            </v-col>
            <RuleTable
                :rule="'bookletTemplate'"
                :items="items"
                :hideEdition="true"
                :hideIntersection="true"
                :accountingCompanyId="accountingCompanyId"
                :maxHeight="maxHeightRT"
                @to-route="routeEdition($event.id)"
                @duplicate="duplicate($event.id)"
                @delete="
                    bookletTemplateToDelete = $event;
                    deleteDialog = true;
                "
            ></RuleTable>
        </v-row>
        <oss-dialog
            v-model="deleteDialog"
            title="Supprimer"
            :error="true"
            @close="bookletTemplateToDelete = undefined"
            @valid="deletePattern()"
            :validLoading="deleteLoading"
            width="800px"
        >
            <h4 class="text-center">
                &#xca;tes-vous sûr(e) de vouloir supprimer ce modèle de plaquette ?
            </h4>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { User } from "../../store/store";

import { Apollo } from "@/decorators";

import BookletTemplate from "./BookletTemplate.vue";
import RuleTable from "./RuleTable.vue";

import BOOKLET_TEMPLATES_ADMIN from "../../graphql/booklet/BookletTemplatesAdmin.gql";
import BOOKLET_TEMPLATES_SCOPING from "../../graphql/booklet/BookletTemplatesScoping.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        BookletTemplate,
        RuleTable,
    },
})
export class BookletTemplates extends Vue {
    // firstRequestDone = false

    // loadingStateNext = true

    // pagination: any = {
    //     page: 1,
    //     rowsPerPage: 20,
    //     sortBy: "name",
    // };

    // operatingAccountCount: number = 0

    search = "";

    filterCompany = null;

    get filterCompanyId() {
        return this.filterCompany?.title && this.filterCompany?.value
            ? this.filterCompany.value
            : null;
    }

    get allAvailableCompanies() {
        const companies = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companies.push({
                value: company.id,
                title: company.name,
            });
            companies.sort((a, b) => {
                if (a.title < b.title) return -1;
                if (a.title > b.title) return 1;
                return 0;
            });
        });
        companies.unshift({ value: "", title: "Toutes mes règles" });

        return companies;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingCompanyId() {
        return this.$store.state.user.company.id;
    }

    get isRootProfile() {
        if (this.currentUser.isRoot) {
            return true;
        }
        return false;
    }

    get maxHeightRT() {
        return "calc(100vh - 160px)";
        const innHeight = window.innerHeight;
        const vhHeight = (200 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    @Watch("search")
    onSearchModified(value) {
        this.items = [];
        // this.pagination.page = 1;
    }

    @Apollo({
        query() {
            return this.filterCompanyId ? BOOKLET_TEMPLATES_SCOPING : BOOKLET_TEMPLATES_ADMIN;
        },
        variables() {
            return this.filterCompanyId
                ? { companyId: this.filterCompanyId }
                : {
                      //   first: this.pagination.rowsPerPage,
                      //   skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                      accountingCompanyId: this.accountingCompanyId,
                      search: this.search ? this.search : undefined,
                      // condition: this.condition
                  };
        },
        skip() {
            return !this.accountingCompanyId;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data) {
                    // this.firstRequestDone = true;
                    this.items.length = 0;
                    if (data?.bookletTemplatesAdmin) {
                        this.items.push(
                            ...data.bookletTemplatesAdmin.filter((x) => x?.companyScope),
                        );
                    } else {
                        if (data?.bookletTemplatesScoping) {
                            this.items.push(
                                ...data.bookletTemplatesScoping.filter((x) => x?.companyScope),
                            );
                        } else {
                            this.items = [];
                            // this.pagination.page = 1;
                        }
                    }
                } else {
                    this.items = [];
                    // this.pagination.page = 1;
                }
            }
        },
    })
    items: Array<any> = [];

    routeEdition(id) {
        this.$router.push({
            name: "booklet-template",
            params: {
                idTemplate: id,
            },
        });
    }

    duplicate(id) {
        this.$router.push({
            name: "new-from-booklet-template",
            params: {
                idToDuplicate: id,
            },
        });
    }

    bookletTemplateToDelete;
    deleteDialog = false;
    deleteLoading = false;

    async deletePattern() {
        this.deleteLoading = true;
        if (this.bookletTemplateToDelete) {
            await this.$apollo.mutate({
                mutation: gql`
                    mutation DeleteBookletTemplate($id: ID!) {
                        deleteBookletTemplate(where: { id: $id }) {
                            id
                        }
                    }
                `,
                variables: {
                    id: this.bookletTemplateToDelete.id,
                },
            });
            this.bookletTemplateToDelete = undefined;
            this.refresh();
        }
        this.deleteDialog = false;
        this.deleteLoading = false;
    }

    refresh() {
        debugger;
        if (this.$apollo.queries && this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        } else {
            debugger;
        }
    }

    @Watch("filterCompanyId")
    filterCompanyIdWatch() {
        this.refresh();
    }
}

export default toNative(BookletTemplates);
</script>
